export default "__VITE_ASSET__DqhNvV_u__"